import React, { memo } from "react";
import { Typography, Box } from "@mui/material";


const Header = ({ title, subtitle }) => {
  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      gap={1} 
      sx={{ mb: 1 }}
    >
      <Typography
        variant="h4"
        color="primary.dark"
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography 
          variant="h5"    
          color="neutral.darkest"
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default memo(Header);
